import { useEffect, useState } from "react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert } from "@mui/material";
import React from "react";

interface AlertProps {
    error: string | null
}

export const AlertView = (props: AlertProps) => {
    const [showError, setShowError] = useState(false);
  
    const handleClose = () => {
        setShowError(false)
    };

    useEffect(() => {
        if (props.error == null) {
            return 
        }

        setShowError(true)
    }, [props.error])

    return (
        showError && props.error != null ? 
        <Alert
            severity="error"
            action={
                <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {handleClose()}}
                >
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            }
        >
            {props.error}
        </Alert> : <React.Fragment/>
    )
}